import { QuickFilterOptions } from '@frontend/api-invoices';
import { createStoreWithSubscribe, createShallowStore } from '@frontend/store';

export type PaymentRequestsPanelStore = {
  selectedStatus: QuickFilterOptions;
  setSelectedStatus: (status: QuickFilterOptions) => void;
};

export const usePaymentRequestsPanelStore = createStoreWithSubscribe<PaymentRequestsPanelStore>(
  (set) => ({
    selectedStatus: 'allInvoices',
    setSelectedStatus: (status: QuickFilterOptions) => set((state) => ({ ...state, selectedStatus: status })),
  }),
  {
    name: 'PaymentRequestsPanelStore',
    trace: true,
  }
);

export const usePaymentRequestsPanelShallowStore = createShallowStore(usePaymentRequestsPanelStore);
